module.exports = __webpack_public_path__ + "static/media/kolob_texto.3e4f4c0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/kolob_texto.svg
// module id = 1790
// module chunks = 0